<script>
import { mapState, mapActions } from 'vuex';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'PricesImportDataTable',
  mixins: [
    dateMixin,
  ],
  data() {
    return {
      headers: [
        { text: 'Product', value: 'product', sortable: false },
        { text: 'From date', value: 'startDate', sortable: false },
        { text: 'To date', value: 'endDate', sortable: false },
        { text: 'Days', value: 'days', sortable: false },
        { text: 'Price', value: 'price', sortable: false },
        { text: 'Discount', value: 'discount', sortable: false },
        { text: 'Min. persons', value: 'minPersons', sortable: false },
        { text: 'Max. persons', value: 'maxPersons', sortable: false },
      ],
    };
  },
  methods: {
    ...mapActions({
    }),
    getProductName(id) {
      const productName = this.channelProducts.items.find(obj => obj.id === id);
      return productName ? productName.tbName : 'None';
    },
  },
  computed: {
    ...mapState({
      channelProducts: state => state.prices.channelProducts,
      list: state => state.prices.list,
    }),
    getStatusMessage() {
      if (this.list.error) {
        return this.list.errorMessage;
      }
      return !this.list.noContent
        ? 'Search for prices by using the filter'
        : 'No content were found with that filter';
    },
  },
};
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="list.items"
    :loading="list.loading"
    class="elevation-1"
    hide-actions
  >
    <template v-slot:no-data>
      <tr>
        <td v-if="!list.loading" :colspan="headers.length" class="text-xs-center">
          {{ getStatusMessage }}
        </td>
        <td v-if="list.loading" :colspan="headers.length" class="text-xs-center">
          Searching...
        </td>
      </tr>
    </template>
    <template v-if="!list.loading" v-slot:items="price">
      <td>{{ getProductName(price.item.xmlChannelProductId) }}</td>
      <td>{{ formatDateSpecific(price.item.startDate, 'DD-MM-YYYY', 'No date') }}</td>
      <td>{{ formatDateSpecific(price.item.endDate, 'DD-MM-YYYY', 'No date') }}</td>
      <td>{{ price.item.days }}</td>
      <td>{{ price.item.price }}</td>
      <td>{{ price.item.discount }}</td>
      <td>{{ price.item.minPersons }}</td>
      <td>{{ price.item.maxPersons }}</td>
    </template>
  </v-data-table>
</template>



// WEBPACK FOOTER //
// src/components/prices/PricesImportDataTable.vue